import * as React from 'react'
import { Layout, Header, Work, Info, Seo } from '../components'
import { graphql } from 'gatsby'

const IndexPage = ({ data }) => {
  const {
    allAgilityproject: { nodes: work },
  } = data

  return (
    <Layout>
      <Seo
        title="Home Page"
        description="The Great Dev Co. is a web design and development agency specializing in building Jamstack websites "
      />
      <Header text="Let’s create something amazing that" home />
      <Work work={work} featured />
      <Info />
    </Layout>
  )
}

export const query = graphql`
  {
    allAgilityproject(filter: { customFields: { featured: { eq: "true" } } }) {
      nodes {
        id
        customFields {
          featured
          name
          tag
          url
          image {
            label
            url
            filesize
            pixelHeight
            pixelWidth
            height
            width
          }
        }
      }
    }
  }
`

export default IndexPage
